import type {
  OrganizationBusinessProfile,
} from '../session/domain/businessProfile';

/**
 * ADR-017 Fase 4: SQLite eliminado como path de datos operacional.
 * `db` es un stub que retorna `undefined`/no-op en todas las plataformas.
 * El cache offline de business profile siempre está vacío; los callers
 * fallan back a bootstrap/remoto.
 */

export async function saveOrganizationBusinessProfileOffline(
  _profile: OrganizationBusinessProfile | null,
): Promise<void> {
  // No-op: SQLite eliminado (ADR-017 Fase 4).
}

export async function getOrganizationBusinessProfileOffline(): Promise<OrganizationBusinessProfile | null> {
  return null;
}

export async function saveBranchCapabilitiesJson(
  _branchId: string,
  _capabilities: string[],
): Promise<void> {
  // No-op: SQLite eliminado (ADR-017 Fase 4).
}
